import state from './currencyState'
import mutations from './currencyMutations'
import getters from './currencyGetters'
import actions from './currencyActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
